import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";

@Component({
	selector: "app-cbta-checkbox-rating",
	templateUrl: "./cbta-checkbox-rating.component.html",
	styleUrls: ["./cbta-checkbox-rating.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaCheckboxRatingComponent implements OnInit {
	@Input() label?: string;
	@Input() isDisabled?: boolean = false;

	@Input() currentValue?: number;
	@Input() rating: 10 | 5 = 5;

	@Output() ratingChange = new EventEmitter();

	constructor() {}

	ngOnInit(): void {}

	// Generate an array of numbers from 0 to steps
	get stepsArray(): number[] {
		return Array(this.rating)
			.fill(0)
			.map((_, i) => i + 1);
	}

	select(event: MatCheckboxChange) {
		if (event.checked) {
			// Uncheck all other checkboxes
			this.currentValue = parseInt(event.source.value, 10); // Parse the value as an integer
			console.log(this.currentValue);
		} else {
			this.currentValue = -2;
		}
		this.ratingChange.emit(this.currentValue); // Emit the current value
	}
}
